import { c as _c } from "react/compiler-runtime";
import { TourCardCarouselBadgesPropertiesType } from "@website/accommodation-ui/tour-card/tour-card-carousel/types";
import { MaterialIcon } from "@website/icons/material";
import { Chips } from "@website/ui/chips";
import { FC } from "react";
export const TourCardCarouselBadges: FC<TourCardCarouselBadgesPropertiesType> = properties => {
  const $ = _c(4);
  const {
    badges
  } = properties;
  let t0;
  if ($[0] !== badges) {
    t0 = badges?.map(_temp);
    $[0] = badges;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <div className="text-caption text-on-color-high-emphasis absolute flex w-full flex-wrap gap-1 p-3">{t0}</div>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
function _temp(item) {
  return <div className="rounded-full px-2 py-1" key={item.title}><Chips StartIcon={item.type === "snappPay" ? <MaterialIcon className="text-xl" name="celebration" variant="outlined" /> : undefined} color={item.color} text={item.title ?? ""} /></div>;
}